// Landing "Built Before GPS. We Still Got There" (sections/lp-gps.liquid): its own animation and block.
// Loaded before the core script (assets/lp1.js), which adds these methods to the page element;
// setUpLook() runs once on load, updateLook(ticked) whenever the after-add popup changes.
window.omLandingParts = window.omLandingParts || [];
window.omLandingParts.push({
    setUpLook() {
      this.setUpMapAgain();
      this.setUpRoute();
    },

    updateLook(ticked) {
      this.updateMarker(ticked.length + 1);
    },

    // "Take the long way": the header map draws the route, drives it and stamps it again.
    setUpMapAgain() {
      const button = this.querySelector('[data-map-again]');
      const map = this.querySelector('[data-map]');
      if (!button || !map) return;
      button.addEventListener('click', () => this.replay(map, 'is-playing'));
    },

    // "Plan the long way": each tapped stop draws the pencil route further toward the lake.
    setUpRoute() {
      const block = this.querySelector('[data-route]');
      if (!block) return;
      const stops = [...block.querySelectorAll('[data-stop]')];
      const line = block.querySelector('[data-route-line]');
      const show = () => {
        const count = stops.filter((stop) => stop.getAttribute('aria-pressed') === 'true').length;
        const share = stops.length ? Math.round((count / stops.length) * 100) : 0;
        if (line) line.setAttribute('stroke-dasharray', share + ' 100');
        this.showPicks(block, count);
        const score = this.scoreFor(block, count);
        if (!score) return;
        block.querySelector('[data-route-title]').textContent = score.title;
        block.querySelector('[data-route-line-text]').textContent = score.line;
      };
      block.addEventListener('click', (event) => {
        const stop = event.target.closest('[data-stop]');
        if (!stop) return;
        stop.setAttribute('aria-pressed', String(stop.getAttribute('aria-pressed') !== 'true'));
        show();
      });
      show();
    },

    // The popup band: mile marker 1, 2 or 3 for 1, 2 or 3+ pieces, and the deal it earns.
    updateMarker(count) {
      const box = this.upsell.querySelector('[data-sheet-marker]');
      if (!box) return;
      const step = Math.min(count, 3);
      box.querySelector('[data-marker-no]').textContent = step;
      box.querySelector('[data-marker-name]').textContent = ['Around the block', 'Over the county line', 'All the way to the lake'][step - 1];
      box.querySelector('[data-marker-deal]').textContent =
        count >= this.discountCount ? this.discountPercent + '% off + free shipping.' : count >= this.freeCount ? 'Free shipping. One more for ' + this.discountPercent + '% off.' : 'Add one more piece and shipping is free.';
    }
});
